import { Context } from '@databases/types/redux';
import { AnyAction } from '@reduxjs/toolkit';

import contextSlice, { ContextState } from './slice';

export interface ContextAppState {
  context: ContextState;
}

export const setContext = (context: Context): AnyAction =>
  contextSlice.actions.setContext(context);
